import { ProdutosTableRow } from '../auxiliarProdutosDaf';

const isSim = (valor?: string): boolean => valor === 'S';

export const buildProdutosTableData = (
  data: any[],
  getTipoProdutoLabel: (item: any) => string,
): ProdutosTableRow[] => {
  return data.map((item) => ({
    id: item?.id ?? 'Não informado',
    status: isSim(item?.statusDistribuicao),

    tipoProduto: getTipoProdutoLabel(item) ?? 'Não informado',

    compBasico: isSim(item?.compBasico),
    compEspecializado: isSim(item?.compEspecializado),
    compEstrategico: isSim(item?.compEstrategico),
    compOncologico: isSim(item?.compOncologico),
    compRara: isSim(item?.compRara),

    produtoFarmaceutico: item?.produtoFarmaceutico ?? 'Não informado',
  }));
};
